// DressGallery.js

import React from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css'; // Import the CSS for styling


const dressImages = [
  {
    original: process.env.PUBLIC_URL + '/click-certi.png',
    thumbnail: process.env.PUBLIC_URL + '/click-certi.png',
  },
  {
    original: process.env.PUBLIC_URL + '/click-im.jpg',
    thumbnail: process.env.PUBLIC_URL + '/click-im.jpg',
  },
  {
    original: process.env.PUBLIC_URL + '/Clic-2.jpg',
    thumbnail: process.env.PUBLIC_URL + '/Clic-2.jpg',
  },
  {
    original: process.env.PUBLIC_URL + '/Elevate.png',
    thumbnail: process.env.PUBLIC_URL + '/Elevate.png',
  },
  {
    original: process.env.PUBLIC_URL + '/Elevate-1.jpg',
    thumbnail: process.env.PUBLIC_URL + '/Elevate-1.jpg',
  },
  {
    original: process.env.PUBLIC_URL + '/Elevate-2.png',
    thumbnail: process.env.PUBLIC_URL + '/Elevate-2.png',
  },
  
  // Add more dress image paths here
];

const UserGallery = () => {
  return (
    <div className="gallery-container" style={{ height: '20%', alignItems: "center" }}>
      <ImageGallery
        items={dressImages}
        showThumbnails={true} // Hide thumbnails
        showFullscreenButton={false} // Hide fullscreen button
        showPlayButton={false} // Hide play button
        autoPlay={true} // Enable autoPlay
        slideDuration={500} // Adjust slide transition duration
        slideInterval={3000} // Adjust slide interval (in milliseconds)
      />
    </div>
  );
};

export default UserGallery;
